import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { FeatureFlagService } from '../../helpers/feature-flag.service';

@Injectable({
  providedIn: 'root'
})
export class HuntRedesignFeatureGuard implements CanActivate {
  constructor(
    private featureFlagService: FeatureFlagService,
    private router: Router
  ) {}

  canActivate(
  ): Observable<boolean> | Promise<boolean> | boolean {
    // Check for hunt redesign access
    if (this.featureFlagService.huntRedesignAccess()) {
      return true;
    }

    // FOR DEVELOPMENT
    return true;

    // If no access, redirect to 404
    this.router.navigate(['/404']);
    return false;
  }
}